module.exports = "/_next/static/images/game-1-phone-gallery-08-25-1513-443a210bb36a11aa04744bc4da94d93f.jpg";